import { useCallback, type RefObject } from 'react'

type TScrollAxis = 'x' | 'y'

export const useScrollToEnd = <TElement extends HTMLElement>(
  containerRef: RefObject<TElement | null>,
  axis: TScrollAxis = 'x',
) =>
  useCallback(() => {
    const container = containerRef.current

    if (!container) {
      return
    }

    container.scrollTo({
      ...(axis === 'x' ? { left: container.scrollWidth } : { top: container.scrollHeight }),
      behavior: 'smooth',
    })
  }, [axis, containerRef])
